// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `._mekaalBQZt9psr7y62z {
	flex-shrink: 0;
	width: 100%;
	z-index: 100;
	font-family: 'Geist', sans-serif;
}
`, "",{"version":3,"sources":["webpack://./src/components/Header/Header.pcss"],"names":[],"mappings":"AAAA;CACC,cAAc;CACd,WAAW;CACX,YAAY;CACZ,gCAAgC;AACjC","sourcesContent":[".header {\n\tflex-shrink: 0;\n\twidth: 100%;\n\tz-index: 100;\n\tfont-family: 'Geist', sans-serif;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"header": `_mekaalBQZt9psr7y62z`
};
export default ___CSS_LOADER_EXPORT___;
